// extracted by mini-css-extract-plugin
export default {"table":"MnemonicMappingTable_table__VDf7C","columnTitle":"MnemonicMappingTable_columnTitle__lSi2v","text":"MnemonicMappingTable_text__bj92q"};